import { render, staticRenderFns } from "./OccurrenceTypeCreate.vue?vue&type=template&id=39490928"
import script from "./OccurrenceTypeCreate.vue?vue&type=script&lang=js"
export * from "./OccurrenceTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports